import { StaticTextStandardSettings } from 'apps/studio/components/settings/fields/StaticText/standard'
import { FieldSettingsPanel } from 'apps/studio/components/settings/fields/Base/standard'
import { ReferenceDataPanel } from 'apps/studio/components/settings/fields/Base/referenceData'
import { DesignSettingsPanel } from 'apps/studio/components/settings/fields/Base/design'
import { AdvancedPanel } from 'apps/studio/components/settings/fields/Base/advanced'

export const StaticTextSettings = [
  FieldSettingsPanel(StaticTextStandardSettings),
  DesignSettingsPanel,
  ReferenceDataPanel,
  // ConditionsPanel,
  AdvancedPanel,
]
